import { Route, Routes } from 'react-router-dom';
import SentEpcisDocumentsOverview from './SentEpcisDocumentsOverview.tsx';
import SentEpcisDocumentsDetail from './SentEpcisDocumentDetail.tsx';

const SentEpcisDocumentsRouter = () => (
  <Routes>
    <Route path="/" element={<SentEpcisDocumentsOverview />} />
    <Route path="/:outboundDocumentId" element={<SentEpcisDocumentsDetail />} />
  </Routes>
);

export default SentEpcisDocumentsRouter;
